/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

export function firstNonNil(arr: any) {
  return _.head(_.filter(arr, (el: any) => !_.isNil(el)));
}

export function firstNonNilProperty<T>(obj: T, arrOfPropertyAccessors: (keyof T)[]) {
  return firstNonNil(_.map(arrOfPropertyAccessors, (path: keyof T) => _.get(obj, path)));
}
